import * as actions from './admin-definitions.actions';
import { AdminDefinitions } from './admin-definitions.interface';
import { initialAdminDefinitionsState } from './admin-definitions.model';

const prepareArray = (keyValueObject: { [key: string]: string }) => {
  const result = Object.keys(keyValueObject).map(key => {
    return { id: key, name: keyValueObject[key] };
  });
  return result.sort((o1, o2) => (o1.name < o2.name ? -1 : 1));
};

export function reducer(state = initialAdminDefinitionsState, action: actions.Actions): AdminDefinitions {
  switch (action.type) {
    case actions.ADMIN_DEFINITIONS_LOAD_SUCCESS:
      // gather all keys, coming from default translations or adminDefinitions, remove duplicates
      const roleKeys = [...Object.keys((action.payload.roles || {})), ...Object.keys((action.payload.adminDefinitions.role || {}))]
        .filter((key, index, arr) => arr.indexOf(key) === index);
      const roles = roleKeys.reduce((result, key) => {
        result[key] = action.payload.roles[key] || action.payload.adminDefinitions.role[key];
        return result;
      }, {});
      return Object.assign({}, state, {
        loaded: true,
        salesOrganisation: prepareArray(action.payload.adminDefinitions.salesOrganisation),
        role: prepareArray(roles),
        language: prepareArray(action.payload.adminDefinitions.language),
      });
    case actions.ADMIN_DEFINITIONS_LOAD_FAIL:
      return state;

    default:
      return state;
  }
}
